export enum AnswerOptionType {
  STANDARD = 'standard',
  CUSTOM_INPUT = 'custom_input',
}
